import React, { useState, useEffect, useCallback } from 'react';
import { isEmpty, pickBy, keys, first, isObject } from 'lodash';
import { connect } from 'react-redux';
import { Popover, Progress } from 'antd';
import BreadExpandTab from '@/components/common/BreadExpandTab';
import css from './ENCompositionDemonstration.less';
import {
  PROGRESS_INFO,
  INFO_MAP,
  getClauseArticle,
  getPhrasesArticle,
  getConjunctionArticle,
  getProposalData,
  getError
} from './utils/enCorrection';

const ENCompositionDemonstration = ({
  all_data,
  overall_result,
  errorWords,
  conjunctionList,
  phrasesList,
  suggestionWord,
  clauseList
}) => {
  const [activeTab, setActiveTab] = useState({});
  const [activeObj, setActiveObj] = useState({});
  const [activeComposition, setActiveComposition] = useState([]);
  const [structureList, setStructureList] = useState({});
  const [breadList, setBreadList] = useState({});

  useEffect(() => {
    const checkList = {
      errorWords,
      conjunctionList,
      phrasesList,
      suggestionWord,
      clauseList
    };
    let res = {};
    res = pickBy(checkList, (_) => !isEmpty(_));
    setBreadList({ ...res });
  }, [errorWords, conjunctionList, phrasesList, suggestionWord, clauseList]);

  useEffect(() => {
    if (isEmpty(all_data)) return;

    const errorWordsStruc = getError(all_data);
    const suggestionWordStruc = getProposalData(all_data);
    const conjunctionListStruc = getConjunctionArticle(all_data);
    const phrasesListStruc = getPhrasesArticle(all_data);
    const clauseListStruc = getClauseArticle(all_data);
    setStructureList({
      errorWordsStruc,
      suggestionWordStruc,
      conjunctionListStruc,
      phrasesListStruc,
      clauseListStruc
    });
  }, [all_data]);

  useEffect(() => {
    const activeType = activeTab.structureName || Object.keys(structureList)[0];
    setActiveComposition(structureList[activeType]);
  }, [activeTab, structureList]);

  useEffect(() => {
    const head = first(keys(structureList));
    const type = head?.split('Struc')[0];
    setActiveComposition(structureList[head]);
    setActiveTab({
      type,
      structureName: head,
      titleColor: INFO_MAP[type]?.titleColor
    });
  }, [structureList]);

  const handleBreadItemClick = useCallback((item, index, infoObj) => {
    const { highlightColor, type, structureName, titleColor } = infoObj;
    setActiveTab({ type, structureName, titleColor });
    setActiveObj({
      ...item,
      highlightColor,
      titleColor,
      active: index + 1
    });
  }, []);

  const handleTextHover = (index) => {
    const { type } = activeTab;
    const { highlightColor } = INFO_MAP[type];
    setActiveObj({
      ...activeObj,
      highlightColor,
      active: index
    });
  };

  const handlePopContent = ({ index }) => {
    const item = breadList[activeTab.type]?.[index - 1];
    switch (activeTab.type) {
      case 'errorWords':
        return item?.error_description;
      case 'suggestionWord':
        return `把“${item?.word}”调整为“${item?.candidates[0]}”是否更合适？`;
      case 'conjunctionList':
        return `${item?.contentType} ${item?.word} ${item?.ending}`;
      case 'clauseList':
        return `${item?.contentType} ${item?.content} ${item?.ending}`;
      case 'phrasesList':
        return `${item?.meaning}`;
      default:
        return '';
    }
  };

  return (
    <div className={css.enDemoWrap}>
      <div className={css.left}>
        <div className={css.breadExpand}>
          {Object.keys(breadList).map((e, key) => (
            <div style={{ marginTop: '20px' }} key={key}>
              <BreadExpandTab
                index={key}
                options={INFO_MAP}
                type={e}
                data={breadList[e]}
                handleBreadItemClick={handleBreadItemClick}
              />
            </div>
          ))}
        </div>
        {/* eslint-disable no-confusing-arrow */}
        {/* eslint-disable function-paren-newline */}
        <div className={css.content}>
          {activeComposition &&
            activeComposition.length &&
            activeComposition.map((paragraph, key) => (
              <div className={css.articleParagraph} key={key}>
                {paragraph.map((value, index) =>
                  value.isBorder ? (
                    <Popover content={handlePopContent(value)} key={index}>
                      <span
                        className={[
                          css.textWrap,
                          value.isBorder ? css.borderText : ''
                        ].join(' ')}
                        style={{
                          borderColor: activeTab.titleColor,
                          background:
                            activeObj.active === value.index
                              ? activeObj.highlightColor
                              : 'transparent'
                        }}
                        onMouseOver={() => handleTextHover(value.index)}
                        onFocus={() => handleTextHover(value.index)}
                      >
                        {value.text}
                        {value.isBorder && (
                          <span
                            className={css.grade}
                            style={{
                              background: activeTab.titleColor
                            }}
                          >
                            {value.index}
                          </span>
                        )}
                      </span>
                    </Popover>
                  ) : (
                    <span
                      key={index}
                      className={[
                        css.textWrap,
                        value.isBorder ? css.borderText : ''
                      ].join(' ')}
                      style={{
                        borderColor: activeObj.titleColor,
                        background:
                          activeObj.active === value.index
                            ? activeObj.highlightColor
                            : 'transparent'
                      }}
                    >
                      {value.text}
                      {value.isBorder && (
                        <span
                          className={css.grade}
                          style={{ background: activeObj.titleColor }}
                        >
                          {value.index}
                        </span>
                      )}
                    </span>
                  )
                )}
              </div>
            ))}
        </div>
      </div>
      <div className={css.right}>
        <div className={css.score}>
          <div className={css.socreVal}>{overall_result.total_score}</div>
          <div className={css.progress}>
            {overall_result &&
              keys(overall_result.category_score).map((e, i) => {
                const item = overall_result.category_score[e];
                return (
                  isObject(item) && (
                    <div key={i}>
                      <span>{PROGRESS_INFO[e][0]}</span>
                      <Progress
                        style={{ marginBottom: '10px' }}
                        format={() => item.score}
                        strokeColor={PROGRESS_INFO[e][1]}
                        percent={(item.score / 5) * 100}
                      />
                    </div>
                  )
                );
              })}
          </div>
        </div>
        <div className={css.content}>
          {overall_result &&
            keys(overall_result.category_score).map((e, i) => {
              const item = overall_result.category_score[e];
              return (
                isObject(item) && (
                  <div key={i} style={{ marginBottom: '16px' }}>
                    <p style={{ marginBottom: '8px' }}>
                      【{PROGRESS_INFO[e][0]}】
                    </p>
                    <p className={css.categoryContent}>{item.comment}</p>
                  </div>
                )
              );
            })}
          <p style={{ marginBottom: '8px' }}>【总评】</p>
          <p className={css.categoryContent}>{overall_result.total_comment}</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const enCor = state.enCorrect;
  return {
    all_data: enCor.all_data,
    overall_result: enCor.overall_result,
    errorWords: enCor.errorWords,
    conjunctionList: enCor.conjunctionList,
    phrasesList: enCor.phrasesList,
    suggestionWord: enCor.suggestionWord,
    clauseList: enCor.clauseList
  };
};

export default connect(mapStateToProps, null)(ENCompositionDemonstration);
